export type Theme = 'light' | 'dark' | 'system';

export const DEFAULT_THEME: Theme = 'light';
